import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, Checkbox } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.RepGuiaDocParams;
export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class ReporteGuiasDoc extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            FechaCorte: validation.required,
            IdSucursal: validation.required
        };
    }

    onGenerarGuiasDoc = async () => {
        const guiasDoc = await resources.RepGuiasDoc.GenerarGuiasDoc(this.state.value);
        await kea.download(guiasDoc, "Guias documentadas.xlsx");
    }

    onGenerarInventario = async () => {
        const guiasDoc = await resources.RepGuiasDoc.GenerarInventario(this.state.value);
        await kea.download(guiasDoc, "Inventario de mercancía.xlsx");
    }

    onGenerarMercTransito = async () => {
        const guiasDoc = await resources.RepGuiasDoc.GenerarMercTransito(this.state.value);
        await kea.download(guiasDoc, "Mercancía en tránsito.xlsx");
    }

    render() {
        const getField = this.getField;
        const DateTime = getField(kea.DateTime);
        const Sucursal = getField(selectores.Sucursal);
        return (
            <div>
                <kea.Title titulo="Reporte de guias documentadas / inventario" onRegresar={() => history.go("../")} />
                {kea.autogrid(4, [
                    <DateTime field="FechaCorte" label="Fecha de corte" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />
                ])}
                <div className="row">
                    <div className="col-md-12">
                        <div className="btn-group">
                            <kea.Button children="Guias doc." style="success" onClick={this.onGenerarGuiasDoc} disabled={validation.hasError(this.errors())} />
                            <kea.Button children="Inventario" style="success" onClick={this.onGenerarInventario} disabled={validation.hasError(this.errors())} />
                            <kea.Button children="Merc. en tránsito" style="success" onClick={this.onGenerarMercTransito} disabled={validation.hasError(this.errors())} />
                        </div>
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reporteguiasdoc/index.tsx